<template>

  <div id="page-user-list">

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Cari Data</label>
          <vs-input class="mb-4 md:mb-0 w-full" v-model="searchQuery" @input="updateSearchQuery" placeholder="Masukkan kata kunci..." />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tipe</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tanggal</label>
          <datepicker format="yyyy-MM-dd" v-model="dateFilter" @selected="changeDate"></datepicker>
        </div> -->
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">&nbsp;</label>
          <vs-button @click="$router.push({ name: 'bank-account-cashflow-add', params: { id: $route.params.id } })" class="mb-4 md:mb-0 mt-6" color="primary" type="filled">Tambah Data</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6 pt-3">
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="bankCashflowData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :frameworkComponents="frameworkComponents"
        :loadingOverlayComponent="loadingOverlayComponent"
        :loadingOverlayComponentParams="loadingOverlayComponentParams"
      >
      </ag-grid-vue>

      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-3 border border-solid d-theme-border-grey-light rounded d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ bankCashflowData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : bankCashflowData.length }} dari {{ bankCashflowData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-left">
          <vs-pagination
            :total="totalPages"
            :max="7"
            v-model="currentPage" />
        </div>
      </div>

    </div>

    <div class="vx-card p-6 pt-3" id="voucherPrint" style="display: none;">
      <table style="border-collapse: collapse; font-family: sans-serif; font-size: 14px; width: 900px; color: black">
        <tr class="header">
            <td style="border: 2px solid black; padding: 5px; height: 40px; vertical-align: top; width: 20%;">
                <label v-if="print.type == 'KM'">Diterima dari :</label>
                <label v-else>Dibayarkan kepada :</label>
                  <p style="text-align: center; margin-top: 8px; font-size: 16px; font-weight: 600;">{{print.paidTo}}</p>
              </td>
            <td style="border: 2px solid black; padding: 5px; height: 40px; text-align: center; padding: 10px 40px; font-size: 36px; font-weight: 900; font-family: 'Times New Roman'; width: 60%; letter-spacing: -1.5px;" class="title">
              <label style="color: red" v-if="print.type == 'KM'">VOUCHER KAS MASUK</label>
              <label v-else>VOUCHER KAS KELUAR</label>
              <!-- VOUCHER KAS {{ (print.type == 'KM') ? 'MASUK' : 'KELUAR' }} -->
            </td>
            <td style="border: 2px solid black; font-size: 14px; padding: 5px; height: 40px; vertical-align: top; width: 20%">
                Nomor<span style="font-weight: 600; padding: 10px"> : {{print.proof}}</span><br/>
                Tanggal<span style="font-weight: 600; padding: 6px">: {{print.date}}</span>
              </td>
          </tr>
        <tr class="detail-content">
          <td style="border: 2px solid black; border-bottom: none;" colspan="3" class="number">
              <table style="width: 100%; border-collapse: collapse;">
                  <tr class="title" style="text-align: center;">
                    <td style="width: 10%; ">No Akun</td>
                    <td style="width: 70%; border-left: 2px solid black; border-right: 2px solid black;">Uraian</td>
                    <td style="width: 20%;">Jumlah</td>
                  </tr>
                  <tr class="content" style="vertical-align: top; height: 80px">
                    <td style="border-top: 2px solid black; padding: 10px 10px;">

                    </td>
                    <td style="border: 2px solid black; padding: 10px;">
                      <table style="width: 100%">
                        <template v-for="data in print.description">
                        <tr :key="data.id">
                          <template v-if="print.description.length > 1">
                            <td style="border-bottom: 1px solid #E0E0E0" width="80%">{{ data.title }}</td>
                            <td style="border-bottom: 1px solid #E0E0E0" width="2%" align="center">Rp. </td>
                            <td style="border-bottom: 1px solid #E0E0E0" width="18%" align="right">{{data.amount.toLocaleString()}}</td>
                          </template>
                          <template v-else>
                            <td style="border-bottom: 1px solid #E0E0E0" width="80%">{{ data.title }}</td>
                          </template>
                        </tr>
                        </template>
                      </table>
                      <!-- <ul style="list-style-type: circle">
                        <template v-for="data in print.description">
                          <li :key="data.id"> (  )</li>
                        </template>
                      </ul> -->
                    </td>
                    <td style="border-top: 2px solid black; font-size: 16px; border-bottom: 2px solid black; padding: 10px 26px; text-align: center;">
                      <b>Rp. {{print.price}}</b>
                    </td>
                  </tr>
                </table>
            </td>
        </tr>
        <tr class="detail-journal">
          <td colspan="3" style="border: 2px solid black; border-top: none; vertical-align: top; text-align: center; padding: 20px 10px; height: 200px">
              <label class="title" style="font-size: 14px;">Penjurnalan :</label>
              <p class="description"></p>
            </td>
        </tr>
        <tr class="footer">
            <td class="notes" style="border: 2px solid black; font-size: 14px; vertical-align: top; padding: 4px;">
              <label>Catatan :</label>
              <p>{{print.notes}}</p>
            </td>
            <td class="signature" style="border: 2px solid black;" colspan="2">
              <table style="width: 100%; border-collapse: collapse">
                  <tr class="title" style="text-align: center;">
                    <td colspan="5" style="padding: 2px">Tanda Tangan</td>
                  </tr>
                  <tr class="content" style="height: 100px; vertical-align: top; text-align: center;">
                      <td width="20%" class="chairman" style="border-top: 2px solid black;">Pimpinan</td>
                      <td width="20%" class="finance" style="border: 2px solid black; border-bottom: none;">Keuangan</td>
                      <td width="20%" class="cashier" style="border-top: 2px solid black;">Kasir</td>
                      <td width="20%" class="person" style="border: 2px solid black; border-bottom: none;">Yang Mengajukan</td>
                      <td width="20%" class="receiver" style="border-top: 2px solid black;">Penerima</td>
                    </tr>
                </table>
            </td>
        </tr>
      </table>
    </div>



    <vx-card ref="filterCard" title="Export Data" subtitle="Export Data ke dalam format excel" class="user-list-filters mt-base">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row">
            <div class="vx-col w-full md:w-4/12">
              <vs-input type="date" size="medium" label="Dari Tanggal" v-model="startDate" class="w-full mr-2"></vs-input>
            </div>
            <div class="vx-col w-full md:w-4/12">
              <vs-input type="date" size="medium" label="Sampai Tanggal" v-model="endDate" class="w-full mr-2"></vs-input>
            </div>
            <div class="vx-col w-full md:w-4/12">
              <vs-button @click="exportData" class="mb-4 md:mb-0 mt-6" color="primary" type="border">Export Data</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Vue from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper'
const options = {
  name: '',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: ['print.css']
}
Vue.use(VueHtmlToPaper, options)

// Store Module
import moduleBankCashflow from '@/store/bank-cashflow/moduleBankCashflow.js'

// Cell Renderer
import CellRendererActions from './cell-renderer/CellRendererActions.vue'

// Custom loading table
import CustomLoadingOverlay from '@/components/customLoadingOverlay'


export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,

    // Cell Renderer
    CellRendererActions
  },
  data () {
    return {
      startDate: moment(new Date()).subtract(new Date().getDate() - 1, 'days').format('yyyy-MM-DD'),
      endDate: moment(new Date()).format('yyyy-MM-DD'),
      dateFilter: null,
      // Filter Options
      typeFilter: { label: 'All', value: 'all' },
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Kas Masuk', value: 'KM' },
        { label: 'Kas Keluar', value: 'KK' }
      ],

      searchQuery: '',
      popupActive: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        autoHeight: true,
        suppressMenu: true
      },

      print: {
        paidTo: null,
        type: null,
        proof: null,
        date: null,
        description: null,
        notes: null,
        price: 0
      },

      columnDefs: [
        {
          headerName: 'No',
          field: 'no',
          width: 80,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Tipe',
          field: 'type',
          filter: true,
          width: 0,
          hide: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Notes',
          field: 'notes',
          filter: true,
          width: 0,
          hide: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Tanggal',
          field: 'date',
          filter: true,
          width: 150,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Bukti',
          field: 'proof',
          filter: true,
          width: 120,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Dibayarkan Kepada',
          field: 'paidTo',
          filter: true,
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Keterangan',
          field: 'description',
          width: 400,
          filter: true,
          getQuickFilterText: function(params) {
            let descriptions = ''
            if (params.data.description.length > 0) {
              params.data.description.forEach((val) => {
                descriptions += `<li>${val.title}</li>`
              })
            } else {
              descriptions = '-'
            }
            return descriptions;
          },
          cellRenderer (params) {
            let descriptions = ''
            if (params.data.description.length > 0) {
              params.data.description.forEach((val) => {
                descriptions += `<li>${val.title}</li>`
              })
            } else {
              descriptions = '-'
            }
            return `<ul style="list-style: circle">${descriptions}</ul>`
          },
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {'color': 'red', 'white-space': 'normal', 'line-height': 1.5}
            } else {
              return {'white-space': 'normal', 'line-height': 1.5}
            }
          }
        },
        {
          headerName: 'Debit',
          field: 'debit',
          filter: true,
          // width: 150,
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {'color': 'red', 'text-align': 'right'}
            } else {
              return {'text-align': 'right'}
            }
          }
        },
        {
          headerName: 'Kredit',
          field: 'credit',
          filter: true,
          width: 150,
          headerClass: 'header-right',
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Saldo',
          field: 'balance',
          filter: true,
          width: 150,
          headerClass: 'header-right',
          cellClass: 'text-right',
          cellStyle (params) {
            if (params.data.type === 'KM') {
              return {color: 'red'}
            }
          }
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 200,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            printVoucher : this.printVoucher.bind(this),
            getBankCashflow : this.getBankCashflow.bind(this)
          },
          cellStyle: {display: 'flex', 'justify-content': 'center'}
        }
      ],
      bankCashflowData: [],
      paymentMethodData: [],

      // Cell Renderer Components
      components: {
        CellRendererActions
      }
    }
  },
  watch: {
    typeFilter (obj) {
      this.setColumnFilter('type', obj.value)
    },
    dateFilter (obj) {
      this.setColumnFilter('date', moment(String(obj)).format('YYYY-MM-DD'))
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  created () {
    if (!moduleBankCashflow.isRegistered) {
      this.$store.registerModule('bankCashflow', moduleBankCashflow)
      moduleBankCashflow.isRegistered = true
    }
    this.getBankCashflow()
  },
  methods: {
    exportData() {
      const userData  = this.$store.state.AppActiveUser
      window.open(`https://api-finance.sigisystems.com/api/v1/cashflow/export/${userData.company.id}/${this.startDate}/${this.endDate}/excel`, '_blank');
    },
    printVoucher (data) {      
      Object.assign(this.print, {
        paidTo: data.paidTo,
        type: data.type,
        proof: data.proof,
        date: data.date,
        notes: data.notes,
        description: data.description.sort(function(a, b) {
          return b.amount - a.amount;
        }),
        price: (data.type === 'KM') ? data.debit : data.credit
      })

      this.$htmlToPaper('voucherPrint')
    },
    changeDate (e) {
      this.setColumnFilter('date', moment(String(e)).format('YYYY-MM-DD'))
    },
    getBankCashflow () {
      const self              = this
      const bankAccountId     = self.$route.params.id

      self.bankCashflowData = []

      this.$store.dispatch('bankCashflow/getBankCashflow', {
        bank_account_id: bankAccountId
      })
        .then(res => {
          const data = res.data.data
          data.forEach((value, index) => {
            self.bankCashflowData.push({
              id          : value.id,
              employee_id : value.employee.id,
              no          : index + 1,
              paidTo      : value.paid_to,
              type        : (value.type === 'debit') ? 'KM' : 'KK',
              date        : value.date,
              notes       : value.notes,
              proof       : value.number,
              description : value.items,
              debit       : value.debit.toLocaleString(),
              credit      : value.credit.toLocaleString(),
              balance     : (value.balance === null) ? 0 : value.balance.toLocaleString()
            })
          })
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          if (this.gridOptions.api.rowModel.rowsToDisplay.length > 0) {
            this.gridOptions.api.hideOverlay()
          } else {
            this.gridOptions.api.showNoRowsOverlay()
          }
        })
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.typeFilter = this.statusFilter = { label: 'All', value: 'all' }
      this.dateFilter   = null

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  beforeMount () {
    this.frameworkComponents = {
      customLoadingOverlay: CustomLoadingOverlay
    }
    this.loadingOverlayComponent = 'customLoadingOverlay'
    this.loadingOverlayComponentParams = {
      loadingMessage: 'One moment please...'
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.gridOptions.api.sizeColumnsToFit()
    // this.gridOptions.api.setDomLayout('autoHeight')
    this.gridOptions.api.showLoadingOverlay()
  }
}

</script>

<style lang="scss">
  // @import "./style.scss";

.ag-row .ag-cell {
  display: flex;
  align-items: center;
}

.ag-row .text-right {
  flex-direction: row-reverse;
}
</style>
